<template>
  <div class="layout-options-setting-dialog">
    <div class="content-group-default">
      <el-collapse v-model="activeNames" style="width: 100%">
        <controlWidthAndSizeAndZindex :options="options" :ids="ids" />
        <!-- <rowColLayoutSize :options="options" :ids="ids" v-else/> -->
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '1')"
          title="自动布局"
          name="1"
        >
          <template slot="title">
            自动布局
            <!-- 可取消自动布局 暂时屏蔽 -->
            <!-- <span class="title-icon icon-portal-minus" v-if="showRowColLayout" @click.stop="autoLayoutHandle()"></span>
            <span class="title-icon icon-portal-plus" v-else @click.stop="autoLayoutHandle()"></span> -->
          </template>
          <div v-if="showRowColLayout">
            <rowColLayoutSetting :options="options" :ids="ids" @update="handleSet"/>
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '2')"
          title="边距"
          name="2"
        >
          <div>
            <cx-padding
              :paddingTypeFlag.sync="paddingTypeFlag"
              :padding.sync="padding"
              :paddingTop.sync="paddingTop"
              :paddingRight.sync="paddingRight"
              :paddingBottom.sync="paddingBottom"
              :paddingLeft.sync="paddingLeft"
              :sliderMax="500"
            />
            <!--外边距-->
            <!-- <cx-padding
              class="mt16"
              :paddingTypeFlag.sync="marginTypeFlag"
              :padding.sync="margin"
              :paddingTop.sync="marginTop"
              :paddingRight.sync="marginRight"
              :paddingBottom.sync="marginBottom"
              :paddingLeft.sync="marginLeft"
              paddingName="外边距"
              :sliderMax="100"
            /> -->
          </div>
        </el-collapse-item>
        <el-collapse-item
          @mousedown.native="collapseMouseDown($event, '3')"
          title="外观"
          name="3"
        >
          <div class="content-item mb16">
            <slider-and-input :value.sync="opacity" title="透明度" :sliderMax="100" suffix="%" />
          </div>
          <div class="content-item verticallyCenter mb16">
            <span class="mr16">溢出</span>
            <text-setting-overflow :overFlowType.sync="overFlowType" style="flex: 1"></text-setting-overflow>
          </div>
          <!-- <div class="setting-item cx_style mb16" style="line-height: 18px">
            <el-checkbox v-model="isCropping">裁剪内容</el-checkbox>
            <span class="third-text">(仅预览页生效)</span>
            <i class="tips-btn icon-portal-info2"></i>
          </div> -->
          <div class="content-item mb16">
            <border-radius
              :borderTypeFlag.sync="borderTypeFlag"
              :borderRadius.sync="borderRadius"
              :borderTopLeftRadius.sync="borderTopLeftRadius"
              :borderTopRightRadius.sync="borderTopRightRadius"
              :borderBottomRightRadius.sync="borderBottomRightRadius"
              :borderBottomLeftRadius.sync="borderBottomLeftRadius"
            />
          </div>
          <div class="content-item mb24 clearFloat">
            <!-- <div class="checkbox_colorPicker_container mb16">
              <span class="fs14">边框</span>
            </div> -->
            <div class="content-item verticallyCenter mb8">
              <el-checkbox v-model="showBorder">显示边框</el-checkbox>
              <el-tooltip
                popper-class="width200"
                effect="dark"
                content="边框颜色为线性渐变或径向渐变时：背景颜色的透明度必须为1。此时背景模糊不生效；虚线、点线不生效。"
                placement="top"
                :open-delay="1000"
              >
                <span class="tips-btn icon-portal-info2"></span>
              </el-tooltip>
            </div>
            <div class="select-input-container verticallyTop" v-if="showBorder">
                <cx-border
                  :borderWidth.sync="borderWidth"
                  :borderStyle.sync="borderStyle"
                  :borderColor.sync="borderColor"
                  :borderIsThemeColor.sync="borderIsThemeColor"
                  :activeNameColor.sync="borderActiveNameColor"
                  :showGradientBorder="true"
                  :options="options"
                />
            </div>
          </div>
          <div class="content-item">
            <cx-background :background.sync="background" imgType="10" class="mt16" />
          </div>
          <div class="content-item mt16">
            <div class="checkbox_colorPicker_container">
              <span>阴影</span>
              <span class="icon-portal-plus theme-color right-icon" @click="addBoxshadow"></span>
            </div>
            <box-shadow
              :boxShadowH.sync="boxShadowH"
              :boxShadowV.sync="boxShadowV"
              :boxShadowBlur.sync="boxShadowBlur"
              :boxShadowSpread.sync="boxShadowSpread"
              :boxShadowColor.sync="boxShadowColor"
            ></box-shadow>
          </div>
          <div class="content-item mt16">
            <public-style :options="options" :ids="ids"></public-style>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>

  </div>
</template>

<script>
import controlWidthAndSizeAndZindex from "publicSetting/controlWidthAndSizeAndZindex"
import rowColLayoutSize from "publicSetting/rowColLayoutSize"
import rowColLayoutSetting from "./setting/rowColLayoutSetting.vue"
import TextSettingOverflow from "modules/components/textSettingOverflow"
import { withMethodsHistoryCombine } from "utils/revork"
import { isInAutoLayout } from "utils"
import publicStyle from "publicSetting/publicStyle.vue"
export default withMethodsHistoryCombine({
  name: "text-options-data",
  components: {
    controlWidthAndSizeAndZindex,
    rowColLayoutSetting,
    rowColLayoutSize,
    TextSettingOverflow,
    publicStyle
  },
  props: { options: Object },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      this1: this,
      collapseActiveNames: ["1", "2", "3"],
      activeType: 1,
      sliderMax: 360,
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    activeRect() {
      let ids = this.$store.state.states.activeID
      if (ids !== null) {
        this.container_id = ids.container_id
        this.rect_id = ids.rect_id
        return this.$store.state.states.activeID
      } else return null
    },
    showRowColLayout: {
      get() {
        return this.options.hasOwnProperty("showRowColLayout") ? this.options.showRowColLayout : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showRowColLayout", false)
      }
    },
    rowColMargin: {
      get() {
        return this.options?.rowColMargin || 0
      },
      set(newVal) {
        if (!this.options.rowColDirection) {
          this.$changeOptionsEV("vertical", "rowColDirection", false)
        }
        this.$changeOptionsEV(newVal, "rowColMargin", false)
      }
    },
    rowColAlignPositionH: {
      get() {
        return this.options.hasOwnProperty("rowColAlignPositionH") ? this.options.rowColAlignPositionH : "left"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowColAlignPositionH", false)
      }
    },
    rowColAlignPositionV: {
      get() {
        return this.options.hasOwnProperty("rowColAlignPositionV") ? this.options.rowColAlignPositionV : "top"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "rowColAlignPositionV", false)
      }
    },
    paddingTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("paddingTypeFlag")) {
          if (((this.paddingTop === this.paddingRight) === this.paddingLeft) === this.paddingBottom) {
            defaultType = 2
          }
        }
        return this.options.paddingTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTypeFlag", false)
      }
    },
    padding: {
      get() {
        return this.options.padding || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "padding", false)
      }
    },
    paddingTop: {
      get() {
        return this.options.paddingTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingTop", false)
      }
    },
    paddingRight: {
      get() {
        return this.options.paddingRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingRight", false)
      }
    },
    paddingLeft: {
      get() {
        return this.options.paddingLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingLeft", false)
      }
    },
    paddingBottom: {
      get() {
        return this.options.paddingBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "paddingBottom", false)
      }
    },
    marginTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("marginTypeFlag")) {
          if (((this.marginTop === this.marginRight) === this.marginLeft) === this.marginBottom) {
            defaultType = 2
          }
        }
        return this.options.marginTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginTypeFlag", false)
      }
    },
    margin: {
      get() {
        return this.options.margin || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "margin", false)
      }
    },
    marginTop: {
      get() {
        return this.options.marginTop || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginTop", false)
      }
    },
    marginRight: {
      get() {
        return this.options.marginRight || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginRight", false)
      }
    },
    marginBottom: {
      get() {
        return this.options.marginBottom || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginBottom", false)
      }
    },
    marginLeft: {
      get() {
        return this.options.marginLeft || 0
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "marginLeft", false)
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(parseInt(newVal), "opacity", false)
      }
    },
    overFlowType: {
      get() {
        return this.options.hasOwnProperty("overFlowType") ? this.options.overFlowType : "visible"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "overFlowType", false)
      }
    },
    // 是否裁剪内容
    isCropping: {
      get() {
        return this.options.hasOwnProperty("isCropping") ? this.options.isCropping : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isCropping", false)
      }
    },
    bgColorIsThemeColor: {
      get() {
        return this.options.bgColorIsThemeColor || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "bgColorIsThemeColor", false)
      }
    },
    background: {
      get() {
        let background = this.options.background
        if (background && Array.isArray(background) && background.length > 0) {
          return background
        }
        let newBackground = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: this.bgColorIsThemeColor,
            color: this.options.bgColor
          }
        ]
        this.$changeOptionsEV(newBackground, "background", false, false, false, true)
        return newBackground
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "background", false)
      }
    },
    showBorder: {
      get() {
        let showBorder = false
        if (this.options.showBorder === undefined) {
          if (this.options.borderWidth) {
            showBorder = true
          } else {
            showBorder = false
          }
        } else {
          showBorder = this.options.showBorder
        }
        return showBorder
      },
      set(newVal) {
        if (newVal && !this.borderWidth) {
          this.$changeOptionsEV([1, newVal], ["borderWidth", "showBorder"], false)
        } else {
          this.$changeOptionsEV(newVal, "showBorder", false)
        }
      }
    },
    borderStyle: {
      get() {
        return this.options.borderStyle
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderStyle", false)
      }
    },
    borderColor: {
      get() {
        return this.options.borderColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderColor", false)
      }
    },
    borderWidth: {
      get() {
        return this.options.borderWidth
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderWidth", false)
      }
    },
    borderActiveNameColor: {
      get() {
        return this.options.borderActiveNameColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderActiveNameColor", false)
      }
    },
    borderIsThemeColor: {
      get() {
        return this.options.borderIsThemeColor
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderIsThemeColor", false)
      }
    },
    borderTopLeftRadius: {
      get() {
        return Number(this.options.borderTopLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopLeftRadius", false)
      }
    },
    borderTopRightRadius: {
      get() {
        return Number(this.options.borderTopRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTopRightRadius", false)
      }
    },
    borderBottomRightRadius: {
      get() {
        return Number(this.options.borderBottomRightRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomRightRadius", false)
      }
    },
    borderBottomLeftRadius: {
      get() {
        return Number(this.options.borderBottomLeftRadius)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderBottomLeftRadius", false)
      }
    },
    borderRadius: {
      get() {
        return Number(this.options.borderRadius[0])
      },
      set(newVal) {
        this.$changeOptionsEV(
          [[newVal, newVal, newVal, newVal], newVal, newVal, newVal, newVal],
          ["borderRadius", "borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
          false
        )
      }
    },
    borderTypeFlag: {
      get() {
        let defaultType = 1
        if (!this.options.hasOwnProperty("borderTypeFlag")) {
          if (((this.borderRadius[0] === this.borderRadius[1]) === this.borderRadius[2]) === this.borderRadius[3]) {
            defaultType = 2
          }
        }
        return this.options.borderTypeFlag || defaultType
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "borderTypeFlag", false)
      }
    },
    boxShadowColor: {
      get() {
        return this.options.hasOwnProperty("boxShadowColor") ? this.options.boxShadowColor : rgba(255,255,255,1)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowColor", false)
      }
    },
    boxShadowH: {
      get() {
        return this.options.hasOwnProperty("boxShadowH") ? this.options.boxShadowH : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowH", false)
      }
    },
    boxShadowV: {
      get() {
        return this.options.hasOwnProperty("boxShadowV") ? this.options.boxShadowV : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowV", false)
      }
    },
    boxShadowBlur: {
      get() {
        return this.options.hasOwnProperty("boxShadowBlur") ? this.options.boxShadowBlur : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowBlur", false)
      }
    },
    boxShadowSpread: {
      get() {
        return this.options.hasOwnProperty("boxShadowSpread") ? this.options.boxShadowSpread : []
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "boxShadowSpread", false)
      }
    },
    isAutoLayoutElement() {
      return isInAutoLayout(this.$store.state[this.request_prefix], this.ids, this.options) 
    }
  },
  mounted() {
  },
  methods: {
    handleSet(key, val) {
      console.log('key,val :>>',key,val);

      this.$changeOptionsEV(val, key, false)
    },
    collapseMouseDown($event, val) {
      if ($event.target.classList[0] === "el-collapse-item__header") {
        const _index = this.collapseActiveNames.findIndex(it => it === val)
        _index === -1 ? this.collapseActiveNames.push(val) : ""
      }
    },
    autoLayoutHandle() {
      this.showRowColLayout = !this.showRowColLayout
    },
    addBoxshadow() {
      if (!Array.isArray(this.boxShadowH)) {
        this.boxShadowH = [this.boxShadowH]
        this.boxShadowV = [this.boxShadowV]
        this.boxShadowBlur = [this.boxShadowBlur]
        this.boxShadowSpread = [this.boxShadowSpread]
        this.boxShadowColor = [this.boxShadowColor]
      }
      let boxShadowH = JSON.parse(JSON.stringify(this.boxShadowH))
      let boxShadowV = JSON.parse(JSON.stringify(this.boxShadowV))
      let boxShadowBlur = JSON.parse(JSON.stringify(this.boxShadowBlur))
      let boxShadowSpread = JSON.parse(JSON.stringify(this.boxShadowSpread))
      let boxShadowColor = JSON.parse(JSON.stringify(this.boxShadowColor))
      boxShadowH.push(0)
      boxShadowV.push(4)
      boxShadowBlur.push(4)
      boxShadowSpread.push(0)
      boxShadowColor.push("rgba(0,0,0,0.25)")
      this.boxShadowH = boxShadowH
      this.boxShadowV = boxShadowV
      this.boxShadowBlur = boxShadowBlur
      this.boxShadowSpread = boxShadowSpread
      this.boxShadowColor = boxShadowColor
    },
  }
})
</script>

<style scoped lang="scss">
p {
  margin-bottom: 0;
}
.tips-btn {
  margin-top: 1px;
}
.title-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--textColor);
  font-size: 16px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  text-align: center;
  line-height: 24px;
  &:hover {
    background: rgba(31, 35, 41, 0.08);
  }
}
</style>
